import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Box } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { audioVideoSliceActions } from "../../Store/Slices/AudioVideoSlice";
import WaveSurfer from "wavesurfer.js";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";

// Global variables

const AudioButtonWave = (props) => {
  const dispatch = useDispatch();

  const [soundData, setSoundData] = useState(null);
  const [isFinished, setIsFinished] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [uri, setUri] = useState(null);
  const [wavesurferObj, setWavesurferObj] = useState(null);

  // Redux state
  let currentAudioSrc = useSelector(
    (state) => state.audioVideo.currentAudioSrc
  );
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { serverRole } = useSelector((state) => state.defs);

  useEffect(() => {
    let innerFun = async () => {
      if (props) {
        let uri;
        let usernamesplit = userInfo.username.split("@");
        let alias = usernamesplit[usernamesplit.length - 1];
        let port = sessionStorage.getItem("port_data")
          ? sessionStorage.getItem("port_data").split(",")
          : process.env.REACT_APP_PORT_DATA.split(",");
        if (props.expertAudio) {
          uri = `${sessionStorage.getItem("media_url")}audio/${
            props.expertAudio
          }`;
        } else if (props.wordAudio) {
          uri = `${sessionStorage.getItem("media_url")}words_media/audio/${
            props.wordAudio
          }`;
        } else if (props.localUri) {
          if (props.localUri.includes("blob:")) {
            uri = `${props.localUri}`;
          } else {
            let userAnswerAudio = props.localUri.split("/");
            userAnswerAudio = userAnswerAudio[userAnswerAudio.length - 1];
            if (serverRole && serverRole.toLowerCase() == "web_host") {
              uri = `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/${alias}/${userAnswerAudio}`;
              const result = await fetch(uri, {
                mode: "cors",
                method: "HEAD",
              }).catch((err) => {
                console.log("okerr");
              });
              console.log("result", result);
              if (!result.ok) {
                uri = `${
                  sessionStorage.getItem("site_ip")
                    ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                    : process.env.REACT_APP_SERVER_API
                }/media/userUploadedData/default/${userAnswerAudio}`;
                const result1 = await fetch(uri, {
                  mode: "cors",
                  method: "HEAD",
                }).catch((err) => {
                  console.log("okerr");
                });
                if (!result1.ok) {
                  uri = `${
                    sessionStorage.getItem("site_ip")
                      ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                      : process.env.REACT_APP_SERVER_API
                  }/media_2024/userUploadedData/${userAnswerAudio}`;
                }
              }
            } else {
              uri = `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/${userAnswerAudio}`;
            }
          }
        } else if (props.broadcastUri) {
          uri = `${
            sessionStorage.getItem("site_ip")
              ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
              : process.env.REACT_APP_SERVER_API
          }/media/userUploadedData/broadCast/${props.broadcastUri}`;
          console.log("uri", uri);
        } else {
          if (serverRole && serverRole.toLowerCase() == "web_host") {
            uri = `${
              sessionStorage.getItem("site_ip")
                ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                : process.env.REACT_APP_SERVER_API
            }/media/userUploadedData/${alias}/${props.userAnswer}`;
            const result = await fetch(uri, {
              mode: "cors",
              method: "HEAD",
            }).catch((err) => {
              console.log("okerr");
            });
            console.log("result", result);
            if (!result.ok) {
              uri = `${
                sessionStorage.getItem("site_ip")
                  ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                  : process.env.REACT_APP_SERVER_API
              }/media/userUploadedData/default/${props.userAnswer}`;
              const result1 = await fetch(uri, {
                mode: "cors",
                method: "HEAD",
              }).catch((err) => {
                console.log("okerr");
              });
              if (!result1.ok) {
                uri = `${
                  sessionStorage.getItem("site_ip")
                    ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                    : process.env.REACT_APP_SERVER_API
                }/media_2024/userUploadedData/${props.userAnswer}`;
              }
            }
          } else {
            uri = `${
              sessionStorage.getItem("site_ip")
                ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                : process.env.REACT_APP_SERVER_API
            }/media/userUploadedData/${props.userAnswer}`;
          }
        }

        setUri(uri);
        props.playStatus(false);
        const sound = new Audio(uri);
        if (props.volume) {
          sound.volume = props.volume;
        }
        sound.playbackRate = props.playbackValue ? props.playbackValue : 1;
        sound.addEventListener("loadedmetadata", () => {
          if (props.metadata) {
            props.metadata(sound.duration);
          }
        });
        sound.addEventListener("ended", () => {
          props.playStatus(false, true);
          setIsFinished(true);
        });

        if (props.onupdate) {
          sound.ontimeupdate = () => {
            if (!isNaN(sound.duration)) {
              let val = (sound.currentTime / sound.duration) * 100;
              props.onupdate({
                progress: val,
                currentTime: sound.currentTime,
                duration: sound.duration,
              });
            }
          };
        }
        setSoundData(sound);
      }
    };
    innerFun();
  }, [
    props.expertAudio,
    props.userAnswer,
    props.localUri,
    props.wordAudio,
    userInfo,
  ]);

  useEffect(() => {
    console.log("URI", uri);
    if (uri) {
      console.log(":::::", wavesurferObj);
      if (!wavesurferObj) {
        const wavesurfer = WaveSurfer.create({
          container: `${"#" + (props.id ? props.id : "waveform")}`,
          waveColor: "#baa900",
          progressColor: "#5f5600",
          url: uri,
          height: 80,
          // Set a bar width
          interact: false,
        });
        // wavesurfer.on("ready", (arg) => {
        //   console.log("ready");
        //   dispatch(commonSliceActions.setLoader(false));
        // });
        wavesurfer.on("load", () => {
          console.log("load");
          dispatch(commonSliceActions.setLoader(true));
        });
        wavesurfer.on("redrawcomplete", () => {
          setTimeout(() => {
            dispatch(commonSliceActions.setLoader(false));
          }, 1000);
        });
        wavesurfer.on("play", () => {
          setIsPlaying(true);
        });
        wavesurfer.on("pause", () => {
          setIsPlaying(false);
        });
        wavesurfer.on("finish", () => {
          setIsPlaying(false);
        });
        setWavesurferObj(wavesurfer);
      } else {
        dispatch(commonSliceActions.setLoader(true));
        wavesurferObj.load(uri);
        wavesurferObj.setTime(0);
      }
    } else {
      if (wavesurferObj) {
        wavesurferObj.destroy();
        setWavesurferObj(null);
      }
    }
  }, [WaveSurfer, uri]);

  useEffect(() => {
    if (props.playbackValue && wavesurferObj) {
      wavesurferObj.playbackRate = props.playbackValue
        ? props.playbackValue
        : 1;
    }
  }, [props.playbackValue, soundData]);

  useEffect(() => {
    return () => {
      if (wavesurferObj) {
        props.playStatus(false, false, true);
        wavesurferObj.pause();
        wavesurferObj.currentTime = 0;
      }
      dispatch(audioVideoSliceActions.resetState());
    };
  }, [wavesurferObj]);

  useEffect(() => {
    if (currentAudioSrc != uri && soundData) {
      wavesurferObj.pause();
      props.playStatus(false, false, true);
    }
  }, [currentAudioSrc]);

  const playExpertAudio = async () => {
    if (!props.disabled) {
      dispatch(audioVideoSliceActions.setCurrentAudioSrc(uri));
      if (wavesurferObj.isPlaying()) {
        wavesurferObj.pause();
        props.playStatus(false);
      } else {
        wavesurferObj.play();
        props.playStatus(true);
        dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      }
    } else {
      return false;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
      component={"div"}
    >
      <IconButton
        sx={{
          mx: 1,
          border: 1,
          borderColor: "#EFEFEF",
          backgroundColor: "#FFFFFF",
          boxShadow: 2,
          color: "primary.main",
          width: "40px",
          height: "40px",
          alignSelf: "center",
          "&:hover": {
            backgroundColor: "#EFEFEF",
            color: "primary.main",
          },
        }}
        onClick={playExpertAudio}
      >
        {isPlaying ? (
          <PauseIcon
            sx={{
              "@media (min-width: 1636px)": {
                fontSize: "2rem",
              },
            }}
          />
        ) : (
          <PlayArrowIcon
            sx={{
              "@media (min-width: 1636px)": {
                fontSize: "2rem",
              },
            }}
          />
        )}
      </IconButton>
      <Box
        sx={{
          border: 1,
          borderColor: "#D9D9D9",
          mt: 1,
          pt: 2,
          mx: 1,
          height: "12vh",
          borderRadius: 3,
          backgroundColor: "#fff594",
          width: "80%",
        }}
        component={"div"}
        id={props.id ? props.id : "waveform"}
      ></Box>
    </Box>
  );
};

export default AudioButtonWave;
